import {
    SchedulePreviewLadderResult,
    SchedulePreviewPaneFrame,
} from "../SchedulePreviewLadderTable";
import { ScheduleApplyPreviewState } from "../useScheduleApplyPreview";

/** The full-screen preview, laid out like the New schedule drawer's. */
export const ScheduleManualPreviewPane = ({
    preview,
}: {
    preview: ScheduleApplyPreviewState;
}) => (
    <SchedulePreviewPaneFrame>
        <SchedulePreviewLadderResult
            unavailableMessage={
                preview.isRequested
                    ? null
                    : "Preview appears once every row has an amount and a date."
            }
            errorMessage={preview.errorMessage}
            isLoading={preview.ladder.length === 0}
            ladder={preview.ladder}
        />
    </SchedulePreviewPaneFrame>
);
